import type { SvgIconProps } from '@cinch-labs/design-system'
import type { SbBlokData } from '@cinch-nx/data-storyblok'
import { globalStoryblokComponents } from '@cinch-nx/storyblok'
import { StoryblokRendererV2 as StoryblokRenderer } from '@cinch-nx/storyblok-utils'

import { Accordion as DsAccordion } from '../../design-system/accordion'
import type { AccordionVariant } from '../../design-system/accordion'

const variants = {
  white: 'white',
  'light-2': 'light-2',
  dark: 'dark',
} as const satisfies Record<string, AccordionVariant>

export interface StoryblokAccordionItem {
  _uid: string
  component: 'AccordionItem'
  title: string
  icon?: SvgIconProps['name']
  expanded?: boolean
  content?: SbBlokData[]
}

export interface StoryblokAccordionProps {
  items?: StoryblokAccordionItem[]
  variant?: keyof typeof variants
}

export const Accordion = ({ items = [], variant }: StoryblokAccordionProps) => (
  <DsAccordion variant={variant ? variants[variant] : 'white'}>
    {items.map((item) => (
      <DsAccordion.Item
        key={item._uid}
        title={item.title}
        iconName={item.icon || undefined}
        expanded={item.expanded}
      >
        {item.content && item.content.length > 0 && (
          <StoryblokRenderer
            block={item.content}
            components={globalStoryblokComponents}
          />
        )}
      </DsAccordion.Item>
    ))}
  </DsAccordion>
)
